export function calculateTimeAgingInMinutes(upTime, downTime) {
    // Hitung selisih waktu dalam milidetik
    const differenceInMilliseconds = Math.abs(downTime - upTime);

    // Konversi milidetik ke menit
    const differenceInsecond = Math.floor(differenceInMilliseconds / 1000);

    const days = Math.floor(differenceInsecond / 86400);
    const hours = Math.floor((differenceInsecond % 86400) / 3600);
    const mins = Math.floor((differenceInsecond % 3600) / 60);
    const secs = differenceInsecond % 60;

    return `${days} days, ${hours} hours, ${mins} minutes, ${secs} seconds`;
}
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}